<app-map-header (searchOut)="searchFeature($event)"  (layersChecked)="layesSelected($event)" (additionnalLayer)="changeAdditionalLayer($event)"  ></app-map-header>


<main class="style_bg_img">
  <!-- Loader -->
  <div id="global-loader" *ngIf="loading">
    <img src="assets/img/loader.svg" class="loader-img" alt="Loader">
  </div>
  <!-- /Loader -->
  <div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
  </div>
  <div  id="map" class="map"></div>
  <!--        <div class="radar"  [ngStyle]="radarStyle"></div>-->
<!--  <div class="radar" [ngClass]="{'active': radarActive}" [ngStyle]="radarStyle"></div>-->
  <div id="scaleline">
    <!--      <div id="cdt" > </div>-->
  </div>

</main>
<footer style="position:fixed; right:0; bottom:0;" class="">
  <div class="d-flex flex-column p-4">
    <button (click)="getGeoPoistion()" class="btn btn-sm btn-light mt-2 shadow-sm" >
      <i [ngClass]="{'text-primary' : enablegeoLocation}" class=" bi-record-circle"></i>
    </button>
    <!-- <button class="btn btn-sm btn-light mt-2 shadow-sm" data-bs-toggle="modal" data-bs-target="#exampleModalInitialisationDetails">
      <i class="text-primary bi-record-circle"></i>
    </button>-->
    <button (click)="zoomIn()" class="btn btn-sm btn-light mt-2 shadow-sm"><i class="bi-plus-lg"></i></button>
    <button (click)="zoomOut()" class="btn btn-sm btn-light mt-2 shadow-sm"><i class="bi-dash"></i></button>
  </div>
</footer>

<!-- Modal -->

  <div  class="modal fade" id="exampleModalInitialisationDetails" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalInitialisationDetailsLabel" aria-hidden="true" style="background-color: rgba(197, 206, 224, 0.2);" >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0">
        <div class="modal-header border-0 pb-0 align-items-start" appDraggable>
          <h5 class="mb-0" id="exampleModalInitialisationDetailsLabel">Information sur la parcelle</h5>
          <button type="button" class="btn-close ms-md-5" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body ">
          <div class="mb-3">
            <div class="card border-primary mb-3">
              <div class="py-4 card-header bg-primary text-white style_bg_img d-flex justify-content-between align-items-center" style="background-image: url('assets/img/carte_bar.png');">
                <div class="me-3">
                  <h2 class="mb-0 style_bold">{{dataInformation?.nup}}</h2>
                  <p class="mb-0 style_font_size_small">Informations Parcellaires</p>
                </div>
                <!--              <a href="#" class="style_link text-end">Voir la carte</a>-->
              </div>
              <div class="card-body">
                <div *ngIf="dataInformation?.title_number_number" class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>N° Titre</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.title_number_number}}</strong>
                    </div>
                  </div>
                </div>
                <div *ngIf="dataInformation?.title_number_commune_name" class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Commune du TF</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.title_number_commune_name}}</strong>
                    </div>
                  </div>
                </div>

                <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Surface estimée (m²)</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.calculated_area}} m²</strong>
                    </div>
                  </div>
                </div>

                <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Type parcelle</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{getTypeParcel(dataInformation?.register_type)}}</strong>
                    </div>
                  </div>
                </div>

                <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Département</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.departement_name}}</strong>
                    </div>
                  </div>
                </div>

                <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Commune</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.commune_name}}</strong>
                    </div>
                  </div>
                </div>

                <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Arrondissement</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.arrondissement_name}}</strong>
                    </div>
                  </div>
                </div>

                <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Village / quartier</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.quartier_name}}</strong>
                    </div>
                  </div>
                </div>

                <div *ngIf="dataInformation?.local_parcel_identification && dataInformation?.local_parcel_identification != '--' " class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                  <div class="row">
                    <div class="col-sm">
                      <span>Référence locale</span>
                    </div>
                    <div class="col-sm">
                      <strong>{{dataInformation?.local_parcel_identification}}</strong>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

